import { useNavigate } from "react-router-dom";
import { useGeo, geoLabel } from "@/lib/geo";
import { MapPinOff, HeartHandshake } from "lucide-react";

// Shown on the Services home when the detected/selected location is outside enabled service areas.
export function ServiceAreaBanner({ onChangeLocation }) {
    const geo = useGeo();
    const nav = useNavigate();
    if (!geo || geo.services_available) return null;
    return (
        <div className="px-5 pt-4" data-testid="service-area-banner">
            <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4">
                <div className="flex items-start gap-3">
                    <MapPinOff size={20} className="mt-0.5 shrink-0 text-amber-600" />
                    <div className="flex-1">
                        <p className="font-heading text-sm font-bold text-navy">Services coming soon to {geoLabel(geo)}</p>
                        <p className="mt-0.5 text-xs text-navy/60">HOMIIE Services currently run in selected areas only. HOMIIE Care is available across Jodhpur.</p>
                    </div>
                </div>
                <div className="mt-3 flex gap-2">
                    <button data-testid="banner-go-care-btn" onClick={() => nav("/care")} className="flex items-center gap-1.5 rounded-full bg-[#F43F5E] px-3.5 py-2 text-xs font-bold text-white active:scale-95"><HeartHandshake size={14} /> Explore Care</button>
                    <button data-testid="banner-change-location-btn" onClick={onChangeLocation} className="rounded-full border border-navy/15 bg-white px-3.5 py-2 text-xs font-bold text-navy active:scale-95">Change location</button>
                </div>
            </div>
        </div>
    );
}
